module.exports = __webpack_public_path__ + "media/images/front/doctor_identity_verification_request/sample_doctor_license-d3e174d1228f130372d724b01af9b60b.png";